module.exports = __webpack_public_path__ + "img/15.cee69925.png";